import React from "react";

function scoreLabel(n) {
    if (n == null || Number.isNaN(n)) return null;
    if (n === 0) return "E";
    if (n > 0) return `+${n}`;
    return String(n);
}

/** Badge fill: red / gray / black; text stays light for contrast. */
function scoreBadgeClass(n) {
    if (n == null || Number.isNaN(n)) return "";
    if (n < 0) return "bg-red-600 text-white border-red-700/40";
    if (n === 0) return "bg-gray-500 text-white border-gray-600/40";
    return "bg-black text-white border-white/20";
}

export function PlayerAvatarWithScore({
    src,
    alt = "",
    scoreVsPar,
    imgClassName,
    borderClassName = "border border-masters-moss/25",
}) {
    const label = scoreLabel(scoreVsPar);
    return (
        <div className="relative inline-flex shrink-0">
            <img
                className={`rounded-full object-cover ${borderClassName} ${imgClassName}`}
                alt={alt}
                src={src}
            />
            {label != null ? (
                <span
                    className={`absolute bottom-0 right-0 z-[1] min-w-[1.1rem] translate-x-0.5 translate-y-0.5 rounded-sm border px-[3px] py-px text-center text-[9px] font-bold leading-none shadow-sm ${scoreBadgeClass(scoreVsPar)}`}
                >
                    {label}
                </span>
            ) : null}
        </div>
    );
}
